<template>
    <v-select v-model="$i18n.locale" :items="items" item-text="text" item-value="value" @input="input"></v-select>
</template>
<script>
import axios from "@/plugins/axios";

export default {
    data(){
        return {
            items: [
                { text: "한국어", value: "ko" },
                { text: "영어", value: "en" },
                { text: "중국어", value: "cn" }
            ]
        }
    },
    methods: {
        input(locale){
            axios.defaults.headers.common['Accept-Language'] = locale;
        }
    }
}
</script>